import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
// import App from './App';
import * as serviceWorker from "./serviceWorker";
// import Ade from './component/AdeComponent';
// import Muchlis from './container/MuchlisComponent';
// import DinamisComponent from './component/DinamisComponent/DinamisComponent';
import Home from "./container/HomeComponent/HomeComponent";

ReactDOM.render(
  <React.StrictMode>
    {/* <Ade />
    <Muchlis />
    <DinamisComponent /> */}
    <Home />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
